import React, { useEffect, useState } from 'react';
import { formatPhoneNumber, validateName, validatePhoneNumber } from '../lib/stringFormat';
import FixedBottomButton from './FixedBottomButton';
import LabeledInput from './LabeledInput';
import Navbar from './Navbar';

export interface EditUserInfoData {
  name: string;
  tel: string;
  zip: string;
  address1: string;
  address2?: string;
  doorNum?: string;
}

interface EditUserInfoProps {
  /** 초기값 */
  initial: EditUserInfoData;
  joined: boolean;
  /** 변경된 정보를 전달 받는 콜백 */
  onSubmit: (data: EditUserInfoData) => void;
  /** 취소 버튼을 눌렀을 때 호출 */
  onCancel?: () => void;
}

const EditUserInfo: React.FC<EditUserInfoProps> = ({ initial, onSubmit, joined, onCancel }) => {
  const [name, setName] = useState(initial.name);
  const [tel, setTel] = useState(initial.tel);
  const [isValidInput, setIsValidInput] = useState(false);

  const handleTelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneNumber(e.target.value);
    setTel(formatted);
  };
  const [zip, setZip] = useState(initial.zip);
  const [address1, setAddress1] = useState(initial.address1);
  const [address2, setAddress2] = useState(initial.address2 || '');
  const [doorNum, setDoorNum] = useState(initial.doorNum || '');

  window.history.pushState(null, '', window.location.href);


  // props 초기값이 바뀌면 내부 상태 동기화
  useEffect(() => {
    setName(initial.name);
    setTel(formatPhoneNumber(initial.tel));
    setZip(initial.zip);
    setAddress1(initial.address1);
    setAddress2(initial.address2 || '');
    setDoorNum(initial.doorNum || '');
  }, [initial]);

  useEffect(() => {
    if (!validateName(name) || !validatePhoneNumber(tel)) {
      setIsValidInput(false);
    } else {
      setIsValidInput(true);
    }
  }, [name, tel]);

  const handleSubmit = () => {
    if (!validateName(name) || !validatePhoneNumber(tel)) {
      // 유효성 검사 실패 시 처리 (예: 에러 메시지 표시)
      return;
    }

    const rawTel = tel.replace(/-/g, '');
    onSubmit({ name, tel: rawTel, zip, address1, address2, doorNum });
  };

  return (
    <div className="flex h-screen flex-col">
      <Navbar title="서비스 대상 정보 변경" onBack={onCancel} />

      <div className="h-screen-nav overflow-y-auto px-5">
        <div className="mt-[28px] flex flex-col gap-4">
{/*   26.05.08 sora27.jeong 이름, 전화번호 수정 안되게 수정
          <LabeledInput
            label="이름"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="이름을 입력하세요"
            errorText="이름 형식에 맞지 않아요. 다시 입력해주세요."
            onValidate={validateName}
          />
          <LabeledInput
            label="전화번호"
            value={tel}
            onChange={handleTelChange}
            placeholder="전화번호를 입력하세요"
            errorText="전화번호 형식에 맞지 않아요. 다시 입력해 주세요."
            onValidate={validatePhoneNumber}
          />

 */}

          <div className="mb-1 mt-2">
            <div className="mb-5 text-sm font-medium leading-4 text-contentText">이름</div>
            <div className="mb-4 text-lg font-normal leading-5 text-text_sub">{name}</div>
            <div className="mb-1 h-px bg-btText" />
          </div>

          <div className="mb-1 mt-2">
            <div className="mb-5 text-sm font-medium leading-4 text-contentText">전화번호</div>
            <div className="mb-4 text-lg font-normal leading-5 text-text_sub">{tel}</div>
            <div className="mb-1 h-px bg-btText" />
          </div>

          <div className="mb-1 mt-2">
            <div className="mb-5 text-sm font-medium leading-4 text-contentText">주소</div>

            <div className="text-lg font-normal leading-5 text-text_sub">{address1}</div>
            <div className="mb-4 text-lg font-normal leading-5 text-text_sub">{address2}</div>

            <div className="mb-1 h-px bg-btText" />

            <div className="text-xs font-medium leading-4 text-text_sub">
              * 설치주소 변경은 고객센터에 문의해 주세요.
            </div>
          </div>

          {joined && (
            <LabeledInput
              label="공동현관 출입번호"
              value={doorNum}
              onChange={(e) => setDoorNum(e.target.value)}
              placeholder="공동현관 출입번호를 입력하세요"
            />
          )}
        </div>
      </div>
      <FixedBottomButton text="변경" onClick={handleSubmit} disable={!isValidInput} />
    </div>
  );
};

export default EditUserInfo;
